<template>
  <div>
    <label>
      <span v-if="label">{{ label }}</span>
    </label>
    <woot-thumbnail
      v-if="src"
      size="80px"
      :src="src"
      :username="usernameAvatar"
    />
    <div v-if="src && deleteAvatar" class="avatar-delete-btn">
      <woot-button
        color-scheme="alert"
        variant="hollow"
        size="tiny"
        type="button"
        @click="onAvatarDelete"
      >
        {{ this.$t('INBOX_MGMT.DELETE.AVATAR_DELETE_BUTTON_TEXT') }}
      </woot-button>
    </div>
    <label>
      <input
        id="file"
        ref="file"
        type="file"
        :accept="acceptedFormats.join(',')"
        @change="handleImageUpload"
      />
      <slot />
    </label>
  </div>
</template>

<script>
import { checkAcceptedFile } from 'shared/helpers/FileHelper';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    usernameAvatar: {
      type: String,
      default: '',
    },
    deleteAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      acceptedFormats: ['image/png', 'image/jpeg', 'image/gif'],
    };
  },
  watch: {},
  methods: {
    handleImageUpload(event) {
      const [file] = event.target.files;
      if(!checkAcceptedFile(file, this.acceptedFormats)) {
        event.preventDefault();
        this.$refs.file.value = null;
        this.showAlert(this.$t('CONVERSATION.FILE_TYPE_NOT_ACCEPTED'));        
        return;
      }

      this.$emit('change', {
        file,
        url: file ? URL.createObjectURL(file) : null,
      });
    },
    onAvatarDelete() {
      this.$refs.file.value = null;
      this.$emit('onAvatarDelete');
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-delete-btn {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-smaller);
}
</style>
